// @flow

import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {State} from 'redux/types';

import {splitReducer} from '@splitsoftware/splitio-redux';
import {combineReducers} from 'redux';

import {tourOperatorReducer} from 'redux/tourOperator/reducer';
import {uiStateReducer} from 'redux/uiState/reducer';
import {v1Reducer} from 'redux/v1/reducer';

export const reducer: Reducer<State> = combineReducers({
  ui: uiStateReducer,
  v1: v1Reducer,
  tourOperator: tourOperatorReducer,
  split: splitReducer,
});
